export const FETCH_STOCKS_START = 'stocks/FETCH_STOCKS_START';
export const FETCH_STOCKS_SUCCESS = 'stocks/FETCH_STOCKS_SUCCESS';
export const FETCH_STOCKS_FAILURE = 'stocks/FETCH_STOCKS_FAILURE';

export const SET_STOCKS = 'stocks/SET_STOCKS';
